import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import i18n from './i18n';

import "@styles/styles.scss";
import vClickOutside from "click-outside-vue3";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css"; //required if you're not going to override default slots


import loading from "@/components/modal/common/Loading";
import dialog from "@/components/modal/common/Dialog";

import {Carousel, Slide} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { createHead } from '@vueuse/head'
import vue3GoogleLogin from 'vue3-google-login';

import config from "./config";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(vClickOutside);

app.use(createHead());

app.provide("dialog", dialog);
app.provide("loading", loading);

app.use(vue3GoogleLogin, {
    clientId: config.social.google.clientId,
});
app.component("infinite-loading", InfiniteLoading);
app.component("Carousel", Carousel);
app.component("Slide", Slide);

app.mount('#app');
